import { loginWithPassword } from '../../../data/repositories/authRepository.js';

export const loginUser = (contactNumber, password) => loginWithPassword(contactNumber, password);
